<script setup>
import { defineEmits } from 'vue'

const emit = defineEmits(['add-obstacle'])

function add(type, ev) {
  emit('add-obstacle', type, ev)
}
</script>

<template>
  <div class="section">
    <label class="label">Adicionar obstáculo</label>
    <div class="row btn-grid">
      <button class="btn" @click="add('vertical', $event)">Vertical</button>
      <button class="btn" @click="add('oxer', $event)">Oxer</button>
      <button class="btn" @click="add('tripleBar', $event)">Triple bar</button>
      <button class="btn" @click="add('gate', $event)">Gate</button>
      <button class="btn" @click="add('plank', $event)">Plank</button>
      <button class="btn" @click="add('wall', $event)">Muro</button>
      <button class="btn" @click="add('start', $event)">Start</button>
      <button class="btn" @click="add('finish', $event)">Finish</button>
    </div>
    <div class="hint">Dica: segure Alt ao criar Oxer/Triple para informar alturas das barras.</div>
  </div>
</template>

<style scoped>
.label { margin: 0 0 6px; font-size: 13px; color: #9eb3ff; }
</style>
